module.exports = __webpack_public_path__ + "img/reports.4e73df35.svg";